export const OWN_FUNDS = 'own_funds'
export const MORTGAGE = 'mortgage'

export const ALL_FINANCING_TYPES = [OWN_FUNDS, MORTGAGE] as const

export type FinancingType = (typeof ALL_FINANCING_TYPES)[number]
